import { LoadingOutlined } from '@ant-design/icons';
import styled from '@emotion/styled';
import { Divider } from 'antd';
import React, { useEffect, useRef } from 'react';
import { useTranslate } from '@tolgee/react';

interface Props {
  loadMore: () => void;
  hasMore: boolean;
}
const Container = styled.div`
  text-align: center;
  padding: 0 16px;
  .no-more {
    padding: 0;
    margin: 0;
    color: var(--fett-text-quaternary);
    font-size: 12px;
  }
`;

const LoadMore = (props: Props) => {
  const { loadMore, hasMore } = props;
  const ref = useRef<HTMLDivElement>(null);
  const { t } = useTranslate();
  useEffect(() => {
    const obs = new IntersectionObserver(
      (entries) => {
        if (entries[0].intersectionRatio > 0.8) {
          loadMore();
        }
      },
      {
        root: document.querySelector('.store-selector-right'),
        threshold: [1],
      },
    );
    ref.current && obs.observe(ref.current);
    return () => {
      obs.disconnect();
    };
  }, [loadMore]);

  return (
    <Container ref={ref}>
      {hasMore ? (
        <LoadingOutlined />
      ) : (
        <Divider className="no-more">{t('storeSelector.NoMore')}</Divider>
      )}
    </Container>
  );
};
export default LoadMore;
